module.exports = __webpack_public_path__ + "img/logo-zc-edasneo-dark.4587ef7e.webp";